import { DropdownType } from "src/shared/types/src";

export const VALIDATION_REGEX = {
    EMAIL: /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/,
    URL: /(https:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
}

export const EXTERNAL_URL = {
    TnC: 'https://www.eyworks.co.uk/terms-of-service/',
    PRIVACY_POLICY: 'https://www.eyworks.co.uk/privacy-policy/',
    GDPR: 'https://www.eyworks.co.uk/gdpr/'
}

export const CUSTOM_HEADERS = {
    OS_VERSION: 'x-app-os-version',    
    APP_VERSION: 'x-app-version',
    PLATFORM: 'x-platform',
    PAYLOAD_SIGNATURE: 'X-Payload-Signature',
    PAYLOAD_TIMESTAMP: 'X-Payload-Timestamp',
    UNIQUE_DEVICE_ID: 'X-DEVICE-ID'
}

// Private key to be used to encrypt the request body
export const REQ_ENCRYPT_PK = '83b292c7f162820c3077fa72902af85ebd176551a4a70a2743ef79d46cbe2261';

export const REQ_ENCRYPT_VERSION = 'v1';

export const OTP_LENGTH = 6;

export const OTP_RESEND_TIME_LIMIT_IN_SECONDS = 59;

export const LOGIN_OTP_TYPE = {
    ACTIVATION: 'ACTIVATION',
    LOGIN: 'LOGIN'
}

export const ABSENCE_TYPES: DropdownType[] = [
    { id: 1, value: 'Holiday' },
    { id: 2, value: 'Sick' },
    { id: 3, value: 'Absent' },
]

export const ACTIVITY_TYPE = {
    DAILY_DIARY: 'DAILY_DIARY',
    DAILY_DIARY_HOLIDAY: 'DAILY_DIARY_HOLIDAY',
    MEDICINE_FORM: 'MEDICINE_FORM',
    ACCIDENT_SHEET: 'ACCIDENT_SHEET',
    OBSERVATION: 'OBSERVATION',
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT',
    // Report types
    CUSTOM_SUMMATIVE_REPORT: 'CUSTOM_SUMMATIVE_REPORT',
    CUSTOM_TRANSITION_REPORT: 'CUSTOM_TRANSITION_REPORT',
    TRANSITION_REPORT: 'TRANSITION_REPORT',
    SUMMATIVE_REPORT: 'SUMMATIVE_REPORT',
    PROGRESS_CHECK_REPORT: 'PROGRESS_CHECK',
    REPORTS: 'REPORT',
    POSTS: 'POSTS',
    POLL: 'POLL',
    CONFIRMATION_POSTS: 'CONFIRMATION_POSTS'
}

export const NOTIFICATION_EVENT_TYPE = {
    INVOICE_SENT: 'INVOICE_SENT',
    OBSERVATION_PUSLISHED: 'OBSERVATION_PUSLISHED',
    OBSERVATION_COMMENT_ADDED: 'OBSERVATION_COMMENT_ADDED',
    DD_SHARED: 'DD_SHARED',
    DD_PUBLISHED: 'DD_PUBLISHED',
    ACCIDENT_SHEET_CREATED: 'ACCIDENT_SHEET_CREATED',
    MEDICINE_FORM_CREATED: 'MEDICINE_FORM_CREATED',
    OBSERVATION_LOVED: 'OBSERVATION_LOVED',
    ACCIDENT_SHEET_COMPLETED: 'ACCIDENT_SHEET_COMPLETED',
    MEDICINE_FORM_REJECTED: 'MEDICINE_FORM_REJECTED',
    MEDICINE_FORM_APPROVED: 'MEDICINE_FORM_APPROVED',
    MEDICINE_FORM_SUBMITTED: 'MEDICINE_FORM_SUBMITTED',
    MEDICINE_FORM_DOSE_PUBLISHED: 'MEDICINE_FORM_DOSE_PUBLISHED',
    SUMMATIVE_REPORT_PUBLISHED: 'SUMMATIVE_REPORT_PUBLISHED',
    TRANSITION_REPORT_PUBLISHED: 'TRANSITION_REPORT_PUBLISHED',
    CUSTOM_SUMMATIVE_REPORT_PUBLISHED: 'CUSTOM_SUMMATIVE_REPORT_PUBLISHED',
    CUSTOM_TRANSITION_REPORT_PUBLISHED: 'CUSTOM_TRANSITION_REPORT_PUBLISHED',
    PLANNING_SHEET: 'PLANNING_SHEET',
    PROGRESS_CHECK_REPORT_PUBLISHED: 'PROGRESS_CHECK_REPORT_PUBLISHED',
    DOCUMENT_ADDED: 'DOCUMENT_ADDED',
    MESSAGE_RECEIVED: 'MESSAGE_RECEIVED',
    EYENGAGE_POST_PUBLISHED: 'EYENGAGE_POST_PUBLISHED',
    EYENGAGE_COMMENT_ADDED: 'EYENGAGE_COMMENT_ADDED',
    EYENGAGE_POST_REMINDER: 'EYENGAGE_POST_REMINDER',
    SIGN_IN_OUT_ADDED: 'SIGN_IN_OUT_ADDED',
    INSTANT_BOOKING_CONFIRMATION: 'INSTANT_BOOKING_CONFIRMATION',
    APPROVAL_BOOKING_REQUEST: 'APPROVAL_BOOKING_REQUEST',
    APPROVAL_BOOKING_CONFIRMATION: 'APPROVAL_BOOKING_CONFIRMATION',
    APPROVAL_BOOKING_CANCELLATION: 'APPROVAL_BOOKING_CANCELLATION',
    INVOICE_STATEMENT_SENT: 'INVOICE_STATEMENT_SENT',
    TRANSACTION_STATEMENT_SENT: 'TRANSACTION_STATEMENT_SENT',
    MESSAGES_SENT: 'MESSAGES_SENT',
    PROFILE_FORM_SENT: 'PROFILE_FORM_SENT',
    PAYMENT_RECEIPT: 'PAYMENT_RECEIPT',
    DEBTORS_LETTER_SENT: 'DEBTORS_LETTER_SENT',
    CONVERSATION_MESSAGE_RECEIVED: 'CONVERSATION_MESSAGE_RECEIVED',
    EYMEMORIES_DISCOUNT: 'EYMEMORIES_DISCOUNT',
    GENERAL_WEBLINK: 'GENERAL_WEBLINK',
}

export const DATE_FORMATS = {
    YMD: 'yyyy-MM-dd',
    YMD_HMS: 'yyyy-MM-dd HH:mm:ss',
    YMD_HM: 'yyyy-MM-dd HH:mm',
    TIME_AMPM: 'hh:mm aa',
    TIME_24HR: 'HH:mm',
    TIME_24HR_S: 'HH:mm:ss',
    DAY_OF_WEEK: 'EEEE', // Example: Monday, Tuesday etc.
    SHORT_DATE: 'dd MMM, yyyy', // Example: 01 Jan, 2020
    LONG_DATE_WITH_TIME: 'EEE dd MMM, yyyy hh:mm aa', // Example: Tue 01 Jan, 2020 12:00 AM
    SHORT_DATE_WITH_TIME: 'dd MMM, yyyy hh:mm aa' // Example: 01 Jan, 2020 12:00 AM
}

export const MEDIA_TYPE = {
    PDF: 'PDF',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO'
}

export const ENTITY_TYPE = {
    OBSERVATION: 'OBSERVATION',
    EYENGAGE: 'EYENGAGE'
}

export const API_PART_URL = 'eyMan/index.php/parent-app';

export const APP_MESSAGES = {
    noGatewaySetup: 'No payment methods setup. Please contact your childcare provider.',
    generalErrorMessage: 'Something went wrong. Please try again later.',
    addCommentErrorOnUnderReviewObservation: 'Cannot add comment since this observation is under review.',
    childAssociatedWithThisNotificationNotFound: 'The child associated with this notification not found.',
    youCanUploadImagesAndPdfFilesOnly: 'You can upload images and PDF files only.',
}

export const GATEWAY_TYPES = {
    STRIPE: 'STRIPE',
    OPAYO: 'OPAYO',
    WORLDPAY: 'WORLDPAY',
    TAXFREECHILDCARE: 'TAXFREECHILDCARE',
    DIRECTDEBIT: 'DIRECTDEBIT',
    CREDITCARD: 'CREDITCARD',
}

export const ACTIVITY_DETAIL_TYPE = {
    ACCIDENT: 'ACCIDENT',
    MEDICINE: 'MEDICINE',
    REPORT: 'REPORT'
}

export const REGISTRY_ACTION = {
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT'
}

export const ALLOWED_IMAGE_SIZE = 20; // 20MB

export const ALLOWED_AUDIO_VIDEO_SIZE = 100; // 100MB

export const ALLOWED_FILE_SIZE = 31457280; // 30MB

export const ACCIDENT_SHEET_STATUS = {
    PENDING_NURSERY_REVIEW: 'PENDING_NURSERY_REVIEW',
    PENDING_PARENT_REVIEW: 'PENDING_PARENT_REVIEW',
    COMPLETED: 'COMPLETED',
    DRAFT: 'DRAFT'
};

export const ACCIDENT_SHEET_REPORT_TYPES = {
    ACCIDENT: 'ACCIDENT',
    PRE_EXISTING: 'PRE_EXISTING',
    INCIDENT: 'INCIDENT'
};

export const MEDICINE_FORM_STATUS = {
    PENDING_NURSERY_REVIEW: "PENDING_NURSERY_REVIEW",
    PENDING_PARENT_REVIEW: "PENDING_PARENT_REVIEW",
    REJECTED: "REJECTED",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED"
};

export const OBSERVATION_STATUS = {
    PENDING_NURSERY_REVIEW: "PENDING_NURSERY_REVIEW",
    PUBLISHED: "PUBLISHED"
}

export const REPORT_STATUS = {
    PENDING_PARENT_REVIEW: 'PENDING_PARENT_REVIEW',
    COMPLETED: 'COMPLETED',
    SUBMIT_FOR_REVIEW: 'SUBMIT_FOR_REVIEW',
    DRAFT: 'DRAFT'
}

export const TEMPERATURE_PARTS = [
    {
        "id": 1,
        "value": "Left Ear"
    },
    {
        "id": 2,
        "value": "Right Ear"
    },
    {
        "id": 3,
        "value": "Forehead"
    }
]

export const FRAMEWORK_TIERS = {
    TIER_1: 'TIER_1',
    TIER_2: 'TIER_2',
    TIER_3: 'TIER_3',
    TIER_4: 'TIER_4',
    TIER_5: 'TIER_5'
}

export const EYENGAGE_POST_TYPES = {
    POST: 'POST',
    POLL: 'POLL'
}

export const FRAMEWORK_ICON_TYPE = {
    FOUNDATION: 'FOUNDATION',
    STEPS: 'STEPS',
    TRIANGLE: 'TRIANGLE'
}

export const NOTIFICATION_SETTINGS_KEYS = {
    FINANCIALS_INVOICES_PAYMENTS: 'FINANCIALS.INVOICES_PAYMENTS',
    FINANCIALS_OVERDUE_BALANCE_STATEMENTS: 'FINANCIALS.OVERDUE_BALANCE_STATEMENTS',
    UPDATES_COMMUNICATION_MESSAGES: 'UPDATES_COMMUNICATION.MESSAGES',
    UPDATES_COMMUNICATION_OBSERVATIONS: 'UPDATES_COMMUNICATION.OBSERVATIONS',
    UPDATES_COMMUNICATION_DAILY_DIARIES: 'UPDATES_COMMUNICATION.DAILY_DIARIES',
    UPDATES_COMMUNICATION_NEWSFEED: 'UPDATES_COMMUNICATION.NEWSFEED',
    UPDATES_COMMUNICATION_SESSIONS: 'UPDATES_COMMUNICATION.SESSIONS',
    WELLBEING_INCIDENT_ACCIDENT_SHEETS: 'WELLBEING.INCIDENT_ACCIDENT_SHEETS',
    WELLBEING_MEDICINE_FORMS: 'WELLBEING.MEDICINE_FORMS',
    REPORTS_RESOURCES_REPORTS: 'REPORTS_RESOURCES.REPORTS',
    REPORTS_RESOURCES_PLANNING_SHEETS: 'REPORTS_RESOURCES.PLANNING_SHEETS',
    REPORTS_RESOURCES_RESOURCES_DOCUMENTS: 'REPORTS_RESOURCES.RESOURCES_DOCUMENTS',
};

export const PDF_BOOK_PAGE_SIZE = 100;
export const TOAST_AUTO_CLOSE_TIMER = 5000;

export const DEFAULT_NURSERY_BRAND_COLOR = '#3D3D3D'